import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { DialogDetalhePublico } from './Dialog';
import useSetParamsURL from '../../../lib/useSetParamsURL';

interface ModalContextType {
    openModal: (content: string) => void;
    closeModal: () => void
}

const DetalhePublicoContext = createContext<ModalContextType | undefined>(undefined);

export const DetalhePublicoProvider: React.FC<{ children: ReactNode }> = ({ children }) => {

    const { searchParams, clearSingleParamUrl } = useSetParamsURL();
    const codigo = searchParams.get('detalhe-publico')
    const [isOpen, setIsOpen] = useState<string | null>(null);

    const openModal = (content: string) => {
        setIsOpen(content);
    };

    const closeModal = () => {
        setIsOpen(null);
        clearSingleParamUrl("detalhe-publico")
    };

    useEffect(() => {
        if (codigo) setIsOpen(codigo)
    }, [codigo])

    return (
        <DetalhePublicoContext.Provider value={{ openModal, closeModal }}>
            {children}

            {
                (isOpen) &&
                <DialogDetalhePublico
                    open={Boolean(isOpen)}
                    handleClose={closeModal}
                    value={isOpen}
                />
            }
        </DetalhePublicoContext.Provider>
    );
};

// Hook para usar o contexto
export const useDetalhePublico = (): ModalContextType => {
    const context = useContext(DetalhePublicoContext);
    if (!context) throw new Error('useModal must be used within a ModalProvider');
    return context;
};